export const enum SSO_PROVIDERS {
  ENTRAID = 'entraid',
}
